import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { ITagsPanelButtonProps } from './types';
import { BOARD_SECTION_TAGS } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function TagsPanelButton ({
    indicatorNumber,
    tooltip,
    onClick
}: ITagsPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.TAGS}
            indicatorNumber={indicatorNumber}
            title={BOARD_SECTION_TAGS}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.TAGS);
                onClick();
            }}
        />
    );
}
